import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { RefreshCcw, XCircle } from 'lucide-react';

const NAMES = { razorpay: 'Razorpay', pinelabs: 'Pine Labs' };

export const GatewayRetryDialog = ({ offer, gateways, onRetry, onClose }) => {
    const toName = offer && ((gateways || []).find(g => g.key === offer.to)?.name || NAMES[offer.to] || offer.to);
    const fromName = offer && (NAMES[offer.from] || offer.from);
    return (
        <Dialog open={!!offer} onOpenChange={(o) => !o && onClose()}>
            <DialogContent className="max-w-md" data-testid="gateway-retry-dialog">
                <DialogHeader>
                    <DialogTitle className="font-display flex items-center gap-2"><XCircle className="h-5 w-5 text-rose-600" /> Payment didn't go through on {fromName}</DialogTitle>
                    <DialogDescription>
                        {offer?.reason ? <>Reason: <strong data-testid="gateway-retry-reason">{offer.reason}</strong>. </> : null}
                        No money is taken for a declined payment. You can try again right away on <strong>{toName}</strong>, which often works when the other gateway declines.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="gap-2">
                    <Button variant="outline" onClick={onClose} data-testid="gateway-retry-cancel">Not now</Button>
                    <Button className="bg-[#0E2A47] hover:bg-[#0B223A]" onClick={() => onRetry(offer)} data-testid="gateway-retry-confirm">
                        <RefreshCcw className="h-4 w-4 mr-1.5" /> Retry with {toName}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
